"use strict";

var _react = _interopRequireDefault(require("react"));

var _ = require(".");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var api_host = process.env.MIXPANEL_API_BASE || 'https://api.mixpanel.com';

function isEnable(options) {
  return (process.env.NODE_ENV === "production" || options.enableOnDevMode) && options.apiToken;
}

function trackEvent(eventName, properties) {
  if (eventName) _.mixpanel.track(eventName, properties);
}

function trackPageViews(location, pageViews, trackPageViewsAs, getPageViewTransformerFn) {
  if (pageViews && location) {
    var eventName;

    if (pageViews instanceof Object) {
      eventName = pageViews[location.pathname];
    } else if (trackPageViewsAs) {
      eventName = trackPageViewsAs;
    } else if (pageViews === 'all') {
      eventName = "View page ".concat(location.pathname);
    }

    var pageViewEventTransformerFn = new Function('location', getPageViewTransformerFn);
    var event = pageViewEventTransformerFn()(location);
    trackEvent(eventName, event);
  }
}

function getOptions(pluginOptions) {
  var defaultsOptions = {
    apiToken: null,
    enableOnDevMode: true,
    mixpanelConfig: null,
    trackPageViewsAs: null,
    getPageViewTransformerFn: 'return function(location) { return location; }'
  };

  var options = _objectSpread({}, defaultsOptions, {}, pluginOptions);

  return _objectSpread({}, options, {
    isEnable: isEnable(options)
  });
}

exports.onRouteUpdate = function (_ref, pluginOptions) {
  var location = _ref.location;
  var options = getOptions(pluginOptions);

  if (!isEnable(options)) {
    return;
  }

  trackPageViews(location, options.pageViews, options.trackPageViewsAs, options.getPageViewTransformerFn);
};

exports.onClientEntry = function (skip, pluginOptions) {
  var options = getOptions(pluginOptions);

  if (!options.isEnable) {
    _.mixpanel.init('disable', {
      autotrack: false,
      api_host: api_host
    });

    _.mixpanel.disable();

    return;
  }

  var customOptions = _extends({
    track_pageview: false,
    api_host: api_host
  }, options.mixpanelConfig);

  _.mixpanel.init(options.apiToken, customOptions);
};

exports.wrapRootElement = function (_ref2) {
  var element = _ref2.element;
  return _react["default"].createElement(_.MixpanelProvider, null, element);
};